import { monthCloseOutAlertConstants } from '../../actions/constant';

const {
  REOPEN_CLOSEOUT_SUCCESS,
  REOPEN_CLOSEOUT_FAILURE,
  REOPEN_CLOSEOUT_LOADING,
  REOPEN_CLOSEOUT_RESET,
} = monthCloseOutAlertConstants;
const intitialstate: object = {
  response: null,
  getStatus: false,
  loading: false,
};

export const reopenCloseoutReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case REOPEN_CLOSEOUT_SUCCESS: {
      return {
        ...state,
        getStatus: true,
        response: action.payload,
        loading: false,
      };
    }

    case REOPEN_CLOSEOUT_FAILURE:
      return {
        ...state,
        getStatus: false,
        response: action.payload,
        loading: false,
      };

    case REOPEN_CLOSEOUT_LOADING:
      return {
        ...state,
        loading: true,
      };

    case REOPEN_CLOSEOUT_RESET:
      return intitialstate;

    default:
      return state;
  }
};
